const dashboard = {
  root: "Dashboard",
};
export default dashboard;
